import {
  Accordion,
  Badge,
  Button,
  Card,
  Col,
  ListGroup,
  OverlayTrigger,
  Popover,
  Row,
  Tab,
  Table,
  Tabs,
  Tooltip,
} from 'react-bootstrap'
import {KTCard} from '../../../_metronic/helpers'
import {BreadcrumbJeisat} from '../../components/BreadcrumbJeisat'
import {useLazyQuery} from '@apollo/client'
import {GET_ONE_VENTA} from '../../graphql/queries/getVentas'
import {IDataResOneVenta} from '../../graphql/types/ventasType'
import {Spinner} from '../../components/Spinner'
import {useEffect} from 'react'
import {toast} from 'react-toastify'
import {Link, useNavigate, useParams} from 'react-router-dom'
import {parseId, parsePrice} from '../../helpers'
import moment from 'moment'
import {ViewRecibo} from '../../components/OneVenta/ViewRecibo'
import Lottie from 'lottie-react'
import notFoundLottie from '../../assets/lotties/no-found.json'
import {useDisclosure} from '../../hooks/useDisclosure'
import {ModalCancelVenta} from '../../components/OneVenta/ModalCancelVenta'
import {TabActivity} from '../../components/OneVenta/TabActivity'
import {STATUS_VENTA} from '../../helpers/consts'
import {useGetUser} from '../../hooks/useGetUser'

export const OneVentaPage = () => {
  const {user} = useGetUser()
  const {id} = useParams()
  const [gqlGetOneVenta, {data, loading, error, refetch}] = useLazyQuery<IDataResOneVenta>(
    GET_ONE_VENTA,
    {
      fetchPolicy: 'no-cache',
    }
  )
  const navigate = useNavigate()

  const {isOpen, onClose, onOpen} = useDisclosure()

  useEffect(() => {
    if (!id || !Number(id)) {
      navigate('/ventas')
    }
    gqlGetOneVenta({
      variables: {
        id,
      },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  useEffect(() => {
    if (!error) return
    toast.error('Error: ' + error.message)
  }, [error])

  if (loading || !data) {
    return (
      <div>
        <BreadcrumbJeisat
          title='Descripción de venta'
          breadcrumb={[
            {
              title: 'Ventas',
              path: '/ventas',
              isSeparator: false,
              isActive: false,
            },
            {
              title: '',
              path: '',
              isSeparator: true,
              isActive: false,
            },
          ]}
          isBtns={false}
          children={undefined}
        />

        <div style={{height: '40vh'}} className='d-flex align-items-center justify-content-center'>
          <Spinner size='30px' />
        </div>
      </div>
    )
  }

  const venta = data.saleList.edges?.[0]?.node

  if (!venta) {
    return (
      <div>
        <BreadcrumbJeisat
          title='Descripción de venta'
          breadcrumb={[
            {
              title: 'Ventas',
              path: '/ventas',
              isSeparator: false,
              isActive: false,
            },
            {
              title: '',
              path: '',
              isSeparator: true,
              isActive: false,
            },
          ]}
          isBtns={false}
          children={undefined}
        />
        <div className='d-flex align-items-center justify-content-center' style={{height: '60vh'}}>
          <div className='d-flex align-items-center justify-content-around flex-column'>
            <h6>No se encontró venta</h6>
            <div style={{maxWidth: '400px'}}>
              <Lottie animationData={notFoundLottie} />
            </div>
            <Link className='btn btn-info' to='/'>
              Volver al inicio
            </Link>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div>
      <BreadcrumbJeisat
        title='Descripción de venta'
        breadcrumb={[
          {
            title: 'Ventas',
            path: '/ventas',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
          },
        ]}
        isBtns={false}
        children={undefined}
      />

      <div>
        <div className='ms-4 mb-6 d-flex flex-column flex-md-row justify-content-between align-items-center gap-4'>
          <div className=''>
            <h2>ID. Venta: {venta.invoiceId}</h2>
            <div className='d-flex flex-colmun gap-2'>
              <span>Productos: {venta.saleproductthroughSet.edges.length}</span>
              <div className='vr'></div>
              <span>Creada: {moment(venta.created).format('DD MMM [del] YYYY')}</span>
            </div>
          </div>
          {venta.status !== STATUS_VENTA.ANULADA && (
            <div className='d-flex align-items-center gap-4'>
              <Button variant='danger' className='d-flex align-items-center gap-1' onClick={onOpen}>
                <i className='bi bi-exclamation-circle' style={{color: 'inherit'}} />
                Anular venta
              </Button>
              <Link
                to={`/agregar-venta?venta=${id}`}
                className='btn btn-outline-warning border border-warning d-flex align-items-center gap-1'
              >
                <i className='bi bi-pencil' style={{color: 'inherit'}} />
                Editar
              </Link>
            </div>
          )}
        </div>
        <Tabs defaultActiveKey='resume' id='tab-ventas' className='bg-transparent'>
          <Tab eventKey='resume' title='Resumen' className='p-4'>
            <Row>
              <Col lg={4}>
                <Card className='d-flex align-items-center gap-3 flex-row p-4'>
                  <div>Estado:</div>
                  <div>
                    <Badge
                      className='text-light'
                      bg={venta.status === STATUS_VENTA.ABIERTA ? 'primary' : 'dark'}
                    >
                      {venta.status}
                    </Badge>
                  </div>
                </Card>
                <Card className='mt-4'>
                  <Card.Header>
                    <Card.Title>Cliente</Card.Title>
                  </Card.Header>
                  <Card.Body>
                    <Table responsive>
                      <tbody>
                        <tr>
                          <th>Nombre:</th>
                          <td>{venta.client.name}</td>
                        </tr>
                        <tr>
                          <th>¿Ventas postpago?</th>
                          <td>
                            {venta.client.postpaidSales ? (
                              <Badge className='text-light' bg='success'>
                                SI
                              </Badge>
                            ) : (
                              <Badge className='text-light' bg='danger'>
                                NO
                              </Badge>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th>Teléfono:</th>
                          <td>{venta.client.phoneNumber}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </Card.Body>
                </Card>
              </Col>
              <Col lg={8}>
                <Card>
                  <Card.Header>
                    <Card.Title>Información</Card.Title>
                  </Card.Header>
                  <Card.Body>
                    <Table responsive>
                      <tbody>
                        <tr>
                          <th>Tipo de venta</th>
                          <td>{venta.saleType}</td>
                        </tr>
                        <tr>
                          <th>Valor de venta</th>
                          <td>{parsePrice(venta.saleTotal)}</td>
                        </tr>
                        <tr>
                          <th>Cantera</th>
                          <td>{venta.quarry.name}</td>
                        </tr>
                        <tr>
                          <th>Despachos</th>
                          <td>
                            {venta.dispatchSet.edges.length > 0 ? (
                              <OverlayTrigger
                                trigger={['click']}
                                overlay={
                                  <Popover id='popover-basic'>
                                    <Popover.Header as='h3'>Despachos</Popover.Header>
                                    <Popover.Body>
                                      <ListGroup>
                                        {venta.dispatchSet.edges.map(({node: nodeDisp}) => (
                                          <ListGroup.Item
                                            key={nodeDisp.id}
                                            style={{width: '150px'}}
                                          >
                                            <div className='d-flex justify-content-between align-items-center'>
                                              <p className='p-0 m-0'>{nodeDisp.plate}</p>
                                              <Link
                                                to={`/despacho/${parseId(nodeDisp.id)}`}
                                                style={{textDecoration: 'underline'}}
                                                target='_blank'
                                                rel='noopener noreferer'
                                              >
                                                <i className='bi bi-eye' />
                                              </Link>
                                            </div>
                                          </ListGroup.Item>
                                        ))}
                                      </ListGroup>
                                    </Popover.Body>
                                  </Popover>
                                }
                              >
                                <Button variant='link' size='sm'>
                                  {venta.dispatchSet.edges.length} despachos
                                </Button>
                              </OverlayTrigger>
                            ) : (
                              <Badge bg='danger' className='text-light'>
                                {' '}
                                NO
                              </Badge>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                    <h3 className='my-2'>Productos</h3>

                    <Accordion>
                      {venta.saleproductthroughSet.edges.map(({node}) => (
                        <Accordion.Item eventKey={'' + parseId(node.id)} key={node.id}>
                          <Accordion.Header>{node.product.name}</Accordion.Header>
                          <Accordion.Body>
                            <Table responsive>
                              <tbody>
                                <tr>
                                  <th>Cantidad</th>
                                  <td>{node.units}</td>
                                </tr>
                                <tr>
                                  <th>Precio unitario</th>
                                  <td>
                                    {parsePrice(`${Number(node.price) - Number(node.promotion)}`)}
                                    {Number(node.promotion) && (
                                      <OverlayTrigger
                                        overlay={
                                          <Tooltip id={`${parseId(node.id)}-tooltip`}>
                                            El verdadero valor del precio unitario es:{' '}
                                            {parsePrice(node.price)}
                                          </Tooltip>
                                        }
                                      >
                                        <i
                                          className='bi bi-info-circle-fill fs-2 ms-2'
                                          id={`${parseId(node.id)}-tooltip`}
                                        />
                                      </OverlayTrigger>
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <th>Unidad</th>
                                  <td>{node.product.unitType}</td>
                                </tr>
                                <tr className='text-info'>
                                  <th>Descuento</th>
                                  <td>
                                    {Boolean(Number(node.promotion)) ? (
                                      parsePrice(node.promotion)
                                    ) : (
                                      <Badge bg='danger'>No</Badge>
                                    )}
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </Accordion.Body>
                        </Accordion.Item>
                      ))}
                    </Accordion>
                  </Card.Body>
                </Card>

                <Card className='mt-5'>
                  <Card.Body>
                    <h3>Observaciones</h3>
                    <p>{venta.observations || <span className='text-muted'>No registra</span>}</p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Tab>
          {Boolean(Number(user?.tokenAuth.settings.ENVELOPE)) && (
            <Tab eventKey='files' title='Recibo'>
              <KTCard className='p-4'>
                <ViewRecibo venta={venta} />
              </KTCard>
            </Tab>
          )}

          <Tab eventKey='activity' title='Actividad' className='p-4'>
            <KTCard className='p-4'>
              <TabActivity log={venta.salelogSet.edges} />
            </KTCard>
          </Tab>
        </Tabs>
      </div>

      <ModalCancelVenta isOpen={isOpen} onClose={onClose} idVenta={id!} refetch={refetch} />
    </div>
  )
}
